import { GlDisclosureDropdownGroup, GlDisclosureDropdownItem } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { uniqueId } from 'lodash-es';
import { sprintf, __ } from '~/locale';
import { showForkSuggestion } from '~/repository/utils/fork_suggestion_utils';
import DeleteBlobModal from '../delete_blob_modal.vue?vue3';
import { DEFAULT_BLOB_INFO } from '~/repository/constants';
export default {
    name: 'BlobDeleteFileGroup',
    components: {
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        DeleteBlobModal
    },
    inject: {
        selectedBranch: {
            default: ''
        },
        originalBranch: {
            default: ''
        },
        blobInfo: {
            default: ()=>DEFAULT_BLOB_INFO.repository.blobs.nodes[0]
        }
    },
    props: {
        currentRef: {
            type: String,
            required: true
        },
        isEmptyRepository: {
            type: Boolean,
            required: false,
            default: false
        },
        isUsingLfs: {
            type: Boolean,
            required: false,
            default: false
        },
        userPermissions: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'show-fork-suggestion'
    ],
    computed: {
        deleteFileItem () {
            return {
                text: __('Delete'),
                extraAttrs: {
                    'data-testid': 'delete',
                    disabled: this.disabled || !this.userPermissions.createMergeRequestIn
                }
            };
        },
        deleteModalId () {
            return uniqueId('delete-modal');
        },
        deleteModalCommitMessage () {
            return sprintf(__('Delete %{name}'), {
                name: this.blobInfo.name
            });
        },
        shouldShowForkSuggestion () {
            return showForkSuggestion(this.userPermissions, this.isUsingLfs, this.blobInfo);
        }
    },
    methods: {
        showModal () {
            if (this.disabled) {
                return;
            }
            if (this.shouldShowForkSuggestion) {
                this.$emit('show-fork-suggestion');
                return;
            }
            this.$refs[this.deleteModalId].show();
        }
    }
};
